import I18n from 'i18n-js';

import StyledButton, {
  EStyledButtonVariant,
} from '~/components/atoms/StyledButton';

import { ReactComponent as AppleIcon } from '~/assets/images/social-media/apple.svg';
import { ReactComponent as FacebookIcon } from '~/assets/images/social-media/facebook.svg';
import { ReactComponent as GoogleIcon } from '~/assets/images/social-media/google.svg';
import { ReactComponent as SteamIcon } from '~/assets/images/social-media/steam.svg';
import { ReactComponent as TwitchIcon } from '~/assets/images/social-media/twitch.svg';
import { ReactComponent as TwitterIcon } from '~/assets/images/social-media/twitter.svg';

import styles from './PlatformButton.module.scss';

export enum EPlatform {
  APPLE = 'apple',
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  STEAM = 'steam',
  TWITCH = 'twitch',
  TWITTER = 'twitter',
}

const platformComponents = {
  [EPlatform.APPLE]: {
    icon: AppleIcon,
    label: 'MenuView_login_apple',
  },
  [EPlatform.FACEBOOK]: {
    icon: FacebookIcon,
    label: 'MenuView_login_facebook',
  },
  [EPlatform.GOOGLE]: {
    icon: GoogleIcon,
    label: 'MenuView_login_google',
  },
  [EPlatform.STEAM]: {
    icon: SteamIcon,
    label: 'MenuView_login_steam',
  },
  [EPlatform.TWITCH]: {
    icon: TwitchIcon,
    label: 'MenuView_login_twitch',
  },
  [EPlatform.TWITTER]: {
    icon: TwitterIcon,
    label: 'MenuView_login_twitter',
  },
} as const;

type TPlatformButtonProps = {
  platform: EPlatform;
  onProviderClick: (platform: EPlatform) => void;
};

export function PlatformButton({
  platform,
  onProviderClick,
}: TPlatformButtonProps): JSX.Element {
  const Icon = platformComponents[platform].icon;

  return (
    <StyledButton
      key={platform}
      onClick={() => onProviderClick(platform)}
      variant={EStyledButtonVariant.GRAY}
      className={styles.socialButton}
    >
      <Icon className={styles.socialIcon} />
      {I18n.t(platformComponents[platform].label)}
    </StyledButton>
  );
}
